export { default } from './client-authenticated-routes';
